module.exports = __webpack_public_path__ + "img/news.a4fc7d80.png";